import { render, staticRenderFns } from "./fb-gender-pie.vue?vue&type=template&id=62e18864&scoped=true"
import script from "./fb-gender-pie.vue?vue&type=script&lang=js"
export * from "./fb-gender-pie.vue?vue&type=script&lang=js"
import style0 from "./fb-gender-pie.vue?vue&type=style&index=0&id=62e18864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e18864",
  null
  
)

export default component.exports